import { NavigateNextOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";

type TOwnProps = {
  onClick: () => void;
};

const NextButton = (props: TOwnProps) => {
  const { onClick } = props;
  return (
    <IconButton onClick={onClick} size="large">
      <NavigateNextOutlined fontSize="large" />
    </IconButton>
  );
};

export default NextButton;
